<p-tabView [(activeIndex)]="index" (onChange)="getIndex($event)">
    <p-tabPanel header="Fields">
        <app-list [moduleList]="modules"></app-list>
    </p-tabPanel>
    <p-tabPanel header="Sections">
        <app-section [moduleList]="modules"></app-section>
    </p-tabPanel>
    <p-tabPanel [disabled]="true" headerStyleClass="iconPanel">
        <ng-template pTemplate="header">
            <p-menu #configmenuCustom id="config_menu_custom" [model]="configMenuCustomItems" [popup]="true"
                appendTo="body">
            </p-menu>
            <span class="btnBars p-mr-0" (click)="configmenuCustom.toggle($event)">
                <i class="pi pi-bars"></i>
            </span>
        </ng-template>
    </p-tabPanel>
</p-tabView>
